<template>
  <div class="project300-onboarding-item">
    <button
      class="project300-checklist-btn"
      :class="{ 'project300-checklist-btn--checked': checked }"
      @click="handleCheckboxClick"
    >
      <svg
        v-if="checked"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.16245 13.5L2.88745 9.22495L3.9562 8.1562L7.16245 11.3625L14.0437 4.4812L15.1125 5.54995L7.16245 13.5Z"
          fill="#0F0E0E"
        />
      </svg>
    </button>
    <div>
      <div class="project300-onboarding-item__title">
        <span class="title-text mem-font--project300__item mem-font--project300__item--capitalize">{{ title }}</span>
        <a v-if="url" :href="url" class="mem-font--project300__item mem-font--project300__item--link" target="_blank">{{ linkText }}</a>
      </div>
      <ul class="project300-onboarding-item__list mem-font--project300__body">
        <p v-for="(item, index) in listItems" :key="index" class="mb-2">
          <span v-if="item[0] === '•'" class="mx-2" style="font-weight: bold;">•</span>
          <span>{{ item.replace('•', ' ') }}</span>
        </p>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Project300OnboardingItem',
  props: {
    id: {
      type: Number,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: 'Link'
    },
    listItems: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    ...mapActions(['toggleOnboardingItem']),
    handleCheckboxClick() {
      this.$emit('handleCheck', {id: this.id})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/project300.scss";

.project300-checklist-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #BBBBBB;
  background: none;
  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
  padding: 0;
  margin-right: 12px;
  flex-shrink: 0;
  
  &:hover {
    opacity: 1;
  }
  
  &--checked {
    background-color: #8BDF06;
    border: none;
    opacity: 1;
  }
}

:deep(.mem-font--project300__item--link) {
  color: #8BDF06;
} 
</style>